/* global axios */
import ApiClient from '../ApiClient';

class OtpChannel extends ApiClient {
  constructor() {
    super('otp', { accountScoped: true });
  }

  getService() {
    return axios.get(`${this.baseUrl()}/otp/service`);
  }

  createService(name) {
    return axios.post(`${this.baseUrl()}/otp/service`, { name });
  }

  deleteService() {
    return axios.delete(`${this.baseUrl()}/otp/service`);
  }

  createWhatsappSession(config = {}) {
    return axios.post(
      `${this.baseUrl()}/otp/channels/whatsapp_sessions`,
      {},
      config
    );
  }

  getWhatsappSession(sessionKey, config = {}) {
    return axios.get(
      `${this.baseUrl()}/otp/channels/whatsapp_sessions/${sessionKey}`,
      config
    );
  }

  connectWhatsappSession(sessionKey) {
    return axios.post(
      `${this.baseUrl()}/otp/channels/whatsapp_sessions/${sessionKey}/connect`
    );
  }

  getSessions() {
    return axios.get(`${this.baseUrl()}/otp/sessions`);
  }

  getDeliveries() {
    return axios.get(`${this.baseUrl()}/otp/deliveries`);
  }
}

export default new OtpChannel();
